export default {
  // 通用
  'leaderboardActivity.saving': '保存中...',
  'leaderboardActivity.operationSuccess': '操作成功',
  'leaderboardActivity.search': '搜索',
  'leaderboardActivity.reset': '重置',
  'leaderboardActivity.totalRecords': '当前共 {{total}} 条记录',

  // 列表
  'leaderboardActivity.listTitle': '排行榜活动列表',
  'leaderboardActivity.addActivity': '新增活动',
  'leaderboardActivity.colName': '活动名称',
  'leaderboardActivity.colShowTime': '展示时间',
  'leaderboardActivity.colEnableTime': '生效时间',
  'leaderboardActivity.colSettle': '结算',
  'leaderboardActivity.colStatus': '状态',
  'leaderboardActivity.colCreateTime': '创建时间',
  'leaderboardActivity.colUpdateTime': '操作时间',
  'leaderboardActivity.colOperator': '操作人',
  'leaderboardActivity.colOperation': '操作',
  'leaderboardActivity.edit': '编辑',
  'leaderboardActivity.copy': '复制',
  'leaderboardActivity.enable': '启用',
  'leaderboardActivity.disable': '禁用',
  'leaderboardActivity.confirmDisable': '确定禁用该活动？',
  'leaderboardActivity.confirmEnable': '确定启用该活动？',
  'leaderboardActivity.statusNotStarted': '待生效',
  'leaderboardActivity.statusRunning': '进行中',
  'leaderboardActivity.statusEnded': '已结束',
  'leaderboardActivity.statusDisabled': '已禁用',
  'leaderboardActivity.settleDaily': '每日',
  'leaderboardActivity.settleEveryNDays': '每 {{n}} 日',

  // 新增 / 编辑
  'leaderboardActivity.addTitle': '新增排行榜活动',
  'leaderboardActivity.editTitle': '编辑排行榜活动',
  'leaderboardActivity.save': '保存',
  'leaderboardActivity.back': '返回',
  'leaderboardActivity.basicSettings': '活动基本',
  'leaderboardActivity.nameZh': '活动名称（中）',
  'leaderboardActivity.enterNameZh': '请输入活动名称（中）',
  'leaderboardActivity.nameEn': '活动名称（英）',
  'leaderboardActivity.enterNameEn': '请输入活动名称（英）',
  'leaderboardActivity.currency': '币种',
  'leaderboardActivity.selectCurrency': '请选择币种',
  'leaderboardActivity.showTime': '展示时间',
  'leaderboardActivity.selectShowTime': '请选择展示时间',
  'leaderboardActivity.enableTime': '生效时间',
  'leaderboardActivity.selectEnableTime': '请选择生效时间',

  // 榜单记录 / 定榜结果
  'leaderboardActivity.boardRecordsTitle': '定榜结果',
  'leaderboardActivity.all': '全部',
  'leaderboardActivity.export': '导出',
  'leaderboardActivity.operationFail': '操作失败',
  'leaderboardActivity.colActivity': '活动名称',
  'leaderboardActivity.colBoard': '榜单',
  'leaderboardActivity.colBoardName': '榜单名称',
  'leaderboardActivity.colPeriod': '周期',
  'leaderboardActivity.colRank': '名次',
  'leaderboardActivity.colUserAccount': '会员账号',
  'leaderboardActivity.colMetricValue': '指标值',
  'leaderboardActivity.colSnapshotTime': '快照时间',
  'leaderboardActivity.filterActivityDate': '活动日期',
  'leaderboardActivity.colVip': 'VIP等级',
  'leaderboardActivity.selectVip': '请选择VIP等级',
  'leaderboardActivity.colCoin': '币种',
  'leaderboardActivity.colSettleDate': '定榜日期',
  'leaderboardActivity.colYesterdayBet': '昨日有效投注',
  'leaderboardActivity.colTodayBet': '今日有效投注',
  'leaderboardActivity.colActivityTotalBet': '活动内有效投注总额',
  'leaderboardActivity.summaryTitle': '总有效投注额',
  'leaderboardActivity.summaryNote': '全部已开启活动　同一会员只计一次　未上榜会员不计入　不随筛选与翻页变化',
  'leaderboardActivity.summaryMemberCount': '去重后上榜会员 {{count}} 人',
  'leaderboardActivity.summaryLoading': '统计中，请稍候',
  'leaderboardActivity.summaryLoadFail': '数据加载失败，请重试',
  'leaderboardActivity.summaryEmpty': '暂无数据。已开启的活动还没有产生上榜记录。',
  'leaderboardActivity.summaryRetry': '重试',
  'leaderboardActivity.colBetCount': '投注笔数',
  'leaderboardActivity.colProfitRate': '盈利率',
  'leaderboardActivity.colLastBetTime': '最近投注时间',
  'leaderboardActivity.colRewardDue': '应发奖励',
  'leaderboardActivity.colAwardStatus': '发奖状态',
  'leaderboardActivity.rewardTypeCash': '现金',
  'leaderboardActivity.rewardTypePoint': '积分',
  'leaderboardActivity.rewardTypeSpin': '大转盘券',
  'leaderboardActivity.awardPendingConfirm': '待确认',
  'leaderboardActivity.awardPendingGrant': '待发奖',
  'leaderboardActivity.awardGranted': '已发奖',
  'leaderboardActivity.awardRejected': '已拒绝',
  'leaderboardActivity.actionConfirm': '确认发放',
  'leaderboardActivity.actionReject': '拒绝',
  'leaderboardActivity.batchConfirm': '批量确认发放',
  'leaderboardActivity.confirmGrantTip': '确定确认发放选中记录？确认后将进入待发奖，由 16:00 批次发放。',
  'leaderboardActivity.rejectTip': '确定拒绝选中记录？拒绝后不再发放。',
  'leaderboardActivity.noSelection': '请先选择记录',
  'leaderboardActivity.grantSuccess': '操作成功，共 {{n}} 条',

  // 发奖记录
  'leaderboardActivity.awardRecordsTitle': '发奖记录',
  'leaderboardActivity.colRewardType': '奖励类型',
  'leaderboardActivity.colRewardValue': '奖励值',
  'leaderboardActivity.colGrantStatus': '发放状态',
  'leaderboardActivity.colGrantTime': '发放时间',
  'leaderboardActivity.grantPending': '待发放',
  'leaderboardActivity.grantGranted': '已发放',
  'leaderboardActivity.grantFailed': '发放失败',
  'leaderboardActivity.colRejectReason': '拒绝原因',
};
